import { useMemo, useSyncExternalStore } from "react";
import { subscribe, getEntries, summarize } from "./uploadManager";

/**
 * The upload entries of one scope (or all of them), re-rendering on every
 * progress tick. Entries are plain objects; see uploadManager.js.
 */
export const useUploads = (scope = null) => {
  const all = useSyncExternalStore(subscribe, getEntries, getEntries);
  return useMemo(
    () => (scope === null ? all : all.filter((entry) => entry.scope === scope)),
    [all, scope]
  );
};

/** {total, active, done, failed, progress} for a scope, or for everything. */
export const useUploadSummary = (scope = null) => {
  const list = useUploads(scope);
  return useMemo(() => summarize(list), [list]);
};

export default useUploads;
